export default __webpack_public_path__ + "static/featured-image-348d69b2c8f93770827d6b6353542fdf.jpeg";